module.exports = __webpack_public_path__ + "img/ShieldCheck.e9f85dbd.svg";